import { V4UUID } from '@/firebase/database';
import { LaunchFile } from '@/modules/controlCenterModule/components/robotConnection/loadLaunchFilesStrategy';
import {
  removeElement,
  toCamelCase,
  toSnakeCase
} from '@/modules/globalModule/components/helperMethods';
import { PackageT } from '@/modules/nodesCanvasModule/components/storeClasses/packageT';
import JSZip from 'jszip';

/**
 * Generates a launch file for the given package and adds it to the launch folder of
 * the given JSZip
 * @param pkgZip - JSZip of base package folder
 * @param pkg - package to generate launch file of
 */
export const generatePackageLaunchFile = (pkgZip: JSZip, pkg: PackageT) => {
  const launchZip = pkgZip.folder('launch');
  const launchFileText = generatePackageLaunchFileString(pkg);
  launchZip?.file(`${toSnakeCase(pkg.name)}.launch.py`, launchFileText);
};

/**
 * Generates the string representing a lunch file for the given package
 * @param pkg
 * @returns
 */
export const generatePackageLaunchFileString = (pkg: PackageT): string => {
  const nodesLaunchText = pkg.nodes.reduce((accumulator, currNode) => {
    return accumulator.concat(`    launch_description.add_action(Node(
        package='${toSnakeCase(pkg.name)}',
        executable='${toSnakeCase(currNode.name)}',
        name='${toSnakeCase(currNode.name)}'
    ))\n`);
  }, '');
  return `from launch import LaunchDescription
from launch_ros.actions import Node

# customize launch file imports below
${pkg.customText.launchFileImports}
# end launch file import customization

def generate_launch_description():
    launch_description = LaunchDescription()
${nodesLaunchText}
    # customize launch file below
${pkg.customText.launchFileText}
    # end launch file customization
    
    return launch_description
`;
};

export const generatePackageLaunchFileObject = (pkg: PackageT): LaunchFile => {
  return {
    name: `${toSnakeCase(pkg.name)}.launch.py`,
    path: `${toSnakeCase(pkg.name)}/launch/${toSnakeCase(pkg.name)}.launch.py`,
    pkgName: pkg.name,
    text: generatePackageLaunchFileString(pkg),
    pkgId: pkg.id
  };
};

export const updatePackageLaunchFileObject = (pkg: PackageT): LaunchFile => {
  const pkgLaunchFile = generatePackageLaunchFileObject(pkg);
  const currPkgLaunchFile = pkg.launchFiles.find(
    (launchFile: LaunchFile) => launchFile.name === pkgLaunchFile.name
  );
  if (currPkgLaunchFile) {
    removeElement(pkg.launchFiles, currPkgLaunchFile);
  }
  pkg.launchFiles.unshift(pkgLaunchFile);
  return pkgLaunchFile;
};
